import { clearStylePos } from "./clearStylePos";
import { clearStyleSize } from "./clearStyleSize";
import { calculateDropdownPos } from "./calculateDropdownPos";
import { setPosStyles } from "./setPosStyles";
import {
  SetDropdownPosProps,
  SetDropdownPosRes,
} from "./setDropdownPos.interface";

const mockedSizes = { width: 1, height: 1 };

export const setDropdownPos = ({
  mutateDOM = true,
  btn,
  list,
  position,
  alignment,
  reposition,
  hasFixedDropdown,
  fixedPositions,
}: SetDropdownPosProps): SetDropdownPosRes => {
  let newPositions;

  if (mutateDOM && list) {
    clearStylePos(list);
    clearStyleSize(list);
  }

  /** skip first render with 0 height and 0 width (without children) */
  // if (!(listSizes.width && listSizes.height)) return {};

  /** update values after clear */
  const btnRect = btn.getBoundingClientRect();
  const listSizes = list ? list.getBoundingClientRect() : mockedSizes;

  /** CHECK */
  // if (!(listSizes.width && listSizes.height)) return {};

  const { newPos, currentAlignment, currentPosition } = calculateDropdownPos({
    position,
    alignment,
    btnRect,
    listSizes,
    reposition,
  });

  newPositions = { ...newPos };

  if (hasFixedDropdown && fixedPositions) {
    newPositions = {
      ...newPositions,
      ...fixedPositions,
    };
  }

  if (mutateDOM && list) {
    setPosStyles(list, newPositions);
  }

  return {
    currentPosition,
    currentAlignment,
    pos: newPositions,
  };
};
